import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=4f341ca4&scoped=true&"
import script from "./handle.vue?vue&type=script&lang=ts&"
export * from "./handle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f341ca4",
  null
  
)

export default component.exports